import {
  RenderType,
  SectionHeader,
  ToggleButton,
  ToggleButtonGroup,
  extendableComponent,
} from '@graphcommerce/next-ui'
import { Controller, FieldErrors, UseControllerProps } from '@graphcommerce/react-hook-form'
import { BaseTextFieldProps, FormHelperText, SxProps } from '@mui/material'
import React, { useState } from 'react'
import { Selected, useConfigurableContext } from '@graphcommerce/magento-product-configurable/ConfigurableContext/ConfigurableContext'
import { ColorSwatchData } from './ColorSwatchData'
import { ImageSwatchData } from '@graphcommerce/magento-product-configurable/Swatches/ImageSwatchData'
import { TextSwatchData } from './TextSwatchData'
import { SwatchTypeRenderer, SwatchSize } from '@graphcommerce/magento-product-configurable/Swatches/types'
import { ToggleButtonColorGroup } from './ToggleButtonColorGroup'
import { ToggleColorButton } from './ToggleColorButton'

export type ConfigurableOptionsInputProps = {
  setCurrentSku: any
  currentSku: string
  size?: SwatchSize
  sx?: SxProps
  setSelected?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & UseControllerProps<any> &
  Pick<BaseTextFieldProps, 'FormHelperTextProps' | 'helperText'> & {
    optionEndLabels?: Record<string, React.ReactNode>
  }

const renderer: SwatchTypeRenderer = { TextSwatchData, ImageSwatchData, ColorSwatchData }

const compName = 'ConfigurableOptionsInput' as const
const parts = ['buttonGroup', 'button', 'helperText'] as const
const { classes } = extendableComponent(compName, parts)

export function MaterialSelection(props: ConfigurableOptionsInputProps) {
  const {
    size = 'large',
    sx,
    setCurrentSku,
    setSelected,
    currentSku
  } = props

  const { select } = useConfigurableContext(currentSku);

  return (
    <>
      <>
        <SectionHeader
          labelLeft={"Choose Material"}
          sx={{ marginTop: 0 }}
        />
        <ToggleButtonGroup
          required
          exclusive
          onChange={(_, val: string | number) => {
            setSelected(true);
            select({} as Selected);
            setCurrentSku(val);
          }}
          className={classes.buttonGroup}
          size={size}
          sx={sx}
        >
          <ToggleButton
            key={'composite'}
            value={'composite-poker-chips'}
            className={classes.button}
            size={size}
            selected={currentSku === "composite-poker-chips"}
          >
            <TextSwatchData
              store_label='Composite'
              value={"Composite"}
              size={size}
            />
          </ToggleButton>
          <ToggleButton
            key={'clay'}
            value={'clay-poker-chips'}
            className={classes.button}
            size={size}
            selected={currentSku === "clay-poker-chips"}
          >
            <TextSwatchData
              store_label='Clay'
              value={"Clay"}
              size={size}
            />
          </ToggleButton>
          {/* <ToggleButton
            key={'ceramic'}
            value={'ceramic-poker-chips'}
            className={classes.button}
            size={size}
            selected={currentSku === "ceramic-poker-chips"}
          >
            <TextSwatchData
              store_label='Ceramic'
              value={"Ceramic"}
              size={size}
            />
          </ToggleButton> */}
        </ToggleButtonGroup>
      </>
    </>
  )
}
